module.exports = __webpack_public_path__ + "img/trip_sendai01.9cbb729e.jpg";